import { render, staticRenderFns } from "./CourseTranscripts.vue?vue&type=template&id=7253f323&scoped=true"
import script from "./CourseTranscripts.vue?vue&type=script&lang=ts"
export * from "./CourseTranscripts.vue?vue&type=script&lang=ts"
import style0 from "./CourseTranscripts.vue?vue&type=style&index=0&id=7253f323&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253f323",
  null
  
)

export default component.exports